import getters from './getters'
import actions from './actions'
import mutations from './mutations'

/**
 * 状态
 */
export const state = {
  id: '',
  data: null,
  relativedGoods: [],
  commentData: null,
  errorTxt: '',
  mtData: null,
}

const namespaced = true

export const articleModule = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
}
